import React from "react";
import "./ActivityLoader.css";
const ActivityLoader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
};

export default ActivityLoader;
